import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};

const Testimonial = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {
  const outerClasses = classNames(
    'testimonial section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'testimonial-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  // For Foundation Management
  const innerClasses2 = classNames(
    'testimonial-inner section-inner',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames('tiles-wrap', pushLeft && 'push-left');

  return (
    <section {...props} className={outerClasses}>
      <div className='container'>
        <div className={innerClasses} style={{ paddingTop: '80px' }}>
          <h1 className='center-content'>
            Board <span className='text-color-primary'>Members</span>
          </h1>
          <div className={tilesClasses}>
            <div
              className='tiles-item reveal-from-left'
              data-reveal-delay='200'
            >
              <div className='tiles-item-inner'>
                <div>
                  <Image
                    src={require('./../../assets/images/stacie.png')}
                    alt='Features split 01'
                    width={528}
                    height={396}
                  />
                </div>
                <div className='testimonial-item-footer text-xs mt-32 mb-0 has-top-divider'>
                  <span className='testimonial-item-name text-color-high'>
                    Stacie Whisonant
                  </span>
                  <br />
                  <span className='testimonial-item-link'>President</span>
                </div>
              </div>
            </div>

            <div
              className='tiles-item reveal-from-left'
              data-reveal-delay='200'
            >
              <div className='tiles-item-inner'>
                <div>
                  <Image
                    src={require('./../../assets/images/richard.png')}
                    alt='Features split 01'
                    width={528}
                    height={396}
                  />
                </div>
                <div className='testimonial-item-footer text-xs mt-32 mb-0 has-top-divider'>
                  <span className='testimonial-item-name text-color-high'>
                    Richard Adams
                  </span>
                  <br />
                  <span className='testimonial-item-link'>Vice President</span>
                </div>
              </div>
            </div>

            <div
              className='tiles-item reveal-from-right'
              data-reveal-delay='200'
            >
              <div className='tiles-item-inner'>
                <div>
                  <Image
                    src={require('./../../assets/images/brittany.png')}
                    alt='Features split 01'
                    width={528}
                    height={396}
                  />
                </div>
                <div className='testimonial-item-footer text-xs mt-32 mb-0 has-top-divider'>
                  <span className='testimonial-item-name text-color-high'>
                    Brittany Foye
                  </span>
                  <br />
                  <span className='testimonial-item-link'>Treasurer</span>
                </div>
              </div>
            </div>

            <div
              className='tiles-item reveal-from-right'
              data-reveal-delay='200'
            >
              <div className='tiles-item-inner'>
                <div>
                  <Image
                    src={require('./../../assets/images/maryion.png')}
                    alt='Features split 01'
                    width={528}
                    height={396}
                  />
                </div>
                <div className='testimonial-item-footer text-xs mt-32 mb-0 has-top-divider'>
                  <span className='testimonial-item-name text-color-high'>
                    Maryion Clark
                  </span>
                  <br />
                  <span className='testimonial-item-link'>Secretary</span>
                </div>
              </div>
            </div>
            <div
              className='tiles-item reveal-from-right'
              data-reveal-delay='200'
            >
              <div className='tiles-item-inner'>
                <div>
                  <Image
                    src={require('./../../assets/images/deynese.png')}
                    alt='Features split 01'
                    width={528}
                    height={396}
                  />
                </div>
                <div className='testimonial-item-footer text-xs mt-32 mb-0 has-top-divider'>
                  <span className='testimonial-item-name text-color-high'>
                    Deynese Thomas
                  </span>
                  <br />
                  <span className='testimonial-item-link'>Board Member</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='container'>
        <div className={innerClasses2} style={{ paddingBottom: '120px' }}>
          <h1 className='center-content'>
            Foundation <span className='text-color-primary'>Management</span>
          </h1>
          <div className={tilesClasses}>
            <div
              className='tiles-item reveal-from-left'
              data-reveal-delay='200'
            >
              <div className='tiles-item-inner'>
                <div>
                  <Image
                    src={require('./../../assets/images/mythraeyi.png')}
                    alt='Features split 01'
                    width={528}
                    height={396}
                  />
                </div>
                <div className='testimonial-item-footer text-xs mt-32 mb-0 has-top-divider'>
                  <span className='testimonial-item-name text-color-high'>
                    Mythraeyi Venkatesh
                  </span>
                  <br />
                  <span className='testimonial-item-link'>
                    Executive Director
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Testimonial.propTypes = propTypes;
Testimonial.defaultProps = defaultProps;

export default Testimonial;
